<template>
  <v-textarea
    v-model="model"
    v-bind="$attrs"
    :auto-grow="autoGrow"
    :counter="counter"
    :filled="filled"
    :label="label"
    :outlined="outlined"
    :readonly="readonly"
    :rounded="rounded"
    :rules="rules"
  />
</template>

<script>
export default {
  name: "CVITextArea",

  props: {
    autoGrow: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: Number,
      default: null,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String, Object, Boolean],
      default: null,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    rules() {
      const rules = this.required
        ? [...this.validator, (v) => !!v || "Este campo é obrigatório"]
        : [...this.validator];

      return rules;
    },
  },
};
</script>
